import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import { router } from './router';
import { queryClient } from '@/lib/api/query-client';
import { ThemeProvider } from './providers/ThemeProvider';
import { I18nProvider } from './providers/I18nProvider';
import { ErrorBoundary } from '@/components/ui/ErrorBoundary';
import { SkipLink } from '@/components/ui/skip-link';
import { logPerformanceMetrics } from '@/lib/utils/performance';
import { initializeFocusVisible } from '@/lib/utils/focus-visible-polyfill';
import '@/lib/i18n';

/**
 * Root application component - NO global auth check
 * Auth checking happens in LoginPage like Nuxt2
 */

function App() {
  // Initialize focus-visible polyfill and log performance metrics
  useEffect(() => {
    // Initialize focus-visible polyfill for better accessibility
    initializeFocusVisible();
    
    if (process.env.NODE_ENV === 'development') {
      // Wait for initial load to complete
      const timer = setTimeout(() => {
        logPerformanceMetrics();
      }, 1000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <I18nProvider>
            {/* Skip links for keyboard navigation */}
            <SkipLink href="#main-content">
              Skip to main content
            </SkipLink>
            <SkipLink href="#navigation">
              Skip to navigation
            </SkipLink>
            
            <RouterProvider router={router} />
          </I18nProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
